/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import icons from "../../../../assets/icons/icon-collection.svg";
import {
  FaThumbsUp,
  FaRegThumbsUp,
  FaShareAlt,
  FaRegPaperPlane,
} from "react-icons/fa";
import { useHistory } from "react-router-dom";
import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import LinkButton from "../../../../components/LinkButton";
import CustomTextArea from "../../../../components/CustomTextArea";
import Card from "../../../../components/Card";
import {
  likeUnlikeJob,
  saveJobAction,
  reportJobAction,
} from "../../../../redux/actions/jobActions";
import { demoAction } from "../../../../redux/actions/demoActions";
import moment from "moment";

//import createDOMPurify from 'dompurify'
//import { JSDOM } from 'jsdom'

const getRelativePostedTime = (date) => {
  if (!date) return "Unknown date";
  return moment(date).fromNow();
};

const JobCard = ({ job }) => {
  //const window = (new JSDOM('')).window
  //const DOMPurify = createDOMPurify(window)

  const history = useHistory();
  const dispatch = useDispatch();
  const [likes, setLikes] = useState(job.total_likes);
  const [isLiked, setIsLiked] = useState(job.isLikedd);
  const [anchorEl, setAnchorEl] = useState(null);
  const [report, setReport] = useState(false);
  const [reportReason, setReportReason] = useState("");

  const {
    userData: { isRecruiter },
  } = useSelector((store) => store.auth);

  const handleClick = (event) => {
    if (event && event.stopPropagation) event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSaveJob = (id) => {
    saveJobAction(dispatch, id);
    setAnchorEl(null);
  };

  const handleShareJob = (id) => {
    history.push(`/home/${id}/refer`);
    setAnchorEl(null);
  };

  const handleReportJob = () => {
    setReport(true);
  };

  const handleReportChange = (e) => {
    setReportReason(e.target.value);
  };

  const handleReportClose = () => {
    setReport(false);
  };

  const handleReportSubmit = (id) => {
    reportJobAction(dispatch, id, reportReason);
    setReport(false);
  };

  const handleLikeJob = (id) => {
    let likeCount = parseInt(likes);
    setLikes(likeCount + 1);
    setIsLiked("1");
    processLikeUnlike(id);
  };

  const handleUnlikeJob = (id) => {
    let likeCount = parseInt(likes);
    setLikes(likeCount - 1);
    setIsLiked("0");
    processLikeUnlike(id);
  };

  const processLikeUnlike = (id) => {
    const likePayload = {
      job_id: id,
    };

    likeUnlikeJob(dispatch, likePayload);
  };

  const openJobDetails = () => {
    history.push(`/home/${job.id}`);
    const state = {
      ["See more details of job here"]: false,
      ["Apply here"]: true,
      ["  the great people you know right here"]: true,
    };
    demoAction(dispatch, state);
  };

  const postedAgo = getRelativePostedTime(
    job.date_created || job.date_posted || job.created_at
  );

  return (
    <>
      <Card
        additionalClass="mx-md-2 px-5 mb-3  "
        additionalStyle={{
          height: "270px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          position: "relative",
          cursor: "pointer",
        }}
        handleClick={openJobDetails}
      >
        {job.job_tier == 3 && (
          <div
            style={{
              position: "absolute",
              top: "0px",
              right: "-30px",
              backgroundColor: "#d4af37",
              color: "#000",
              padding: "10px 30px",
              fontSize: "8px",
              fontWeight: "bold",
              transform: "rotate(45deg)",
              transformOrigin: "center",
              boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Get Paid
          </div>
        )}
        <div className="d-flex mb-2 align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <img
              src={job.created_by_profile.image_url}
              alt="avatar"
              style={{
                width: "30px",
                height: "30px",
                objectFit: "cover",
                borderRadius: "50%",
                marginRight: "0.75rem",
              }}
            />
            <span className="d-flex flex-column ml-3">
              <h6 className="mb-0">{job.campany_name.substring(0, 10)}</h6>
              <span className="co-gray">
                {job.created_by_profile.first_name}{" "}
                {/* {job.created_by_profile.last_name} */}
              </span>
            </span>
          </div>
          <IconButton onClick={(e) => handleClick(e)}>
            <svg width="20" height="15">
              <use href={`${icons}#dots`}></use>
            </svg>
          </IconButton>
        </div>
        <div className="d-flex justify-content-start align-items-center my-3">
          <span className="mr-3 d-flex align-items-center small-text co-darkgray">
            <svg width="14" height="14" className="mr-1">
              <use href={`${icons}#mappin`}></use>
            </svg>
            {job.location || "Location not specified"}
          </span>
          <span className="co-gray small-text">
            Posted {postedAgo}
          </span>
        </div>
        <Divider />

        {/* <DemoPointer text="See more details of job here" position="top"> */}
        <div className="pb-3">
          <b className="d-block my-3 co-primary">{job.role_title.substring(0, 60)}</b>
          <span>
            {/* <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.about_company.substring(0, 25)) }}></span> */}
            {/* <span dangerouslySetInnerHTML={{ __html: job.about_company.substring(0, 160) }}></span> }*/}
            {job.about_company.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 10)}{" "}
            ...
            <button
              style={{ display: "inline" }}
              type="button"
              onClick={(e) => { e.stopPropagation(); openJobDetails(); }}
              className="co-primary bg-white borderless"
            >
              <b>See More</b>
            </button>
          </span>
        </div>
        {/*  </DemoPointer> */}

        <div className="d-flex align-items-center justify-content-between mb-2">
          <span className="small-text thin-text"> {likes} Likes</span>
          <span>
            {/* <img src={SmallPlaceholder} alt="avatar" className="mx-1" />
                    <img src={SmallPlaceholder} alt="avatar" className="mx-1" />
                    <img src={SmallPlaceholder} alt="avatar" className="mx-1" /> */}
          </span>
        </div>

        <Divider />

        <div className="d-flex pt-2 align-items-center justify-content-between">
          {isLiked === "0" ? (
            <LinkButton
              label="Like"
              icon={
                <FaThumbsUp
                  size={14}
                  style={{
                    marginRight: "0.3rem",
                    marginTop: "10px",
                    color: "#0d6efd",
                  }}
                />
              }
              onClick={(e) => { e.stopPropagation(); handleLikeJob(job.id); }}
            />
          ) : (
            <LinkButton
              label="Unlike"
              icon={
                <FaRegThumbsUp
                  size={15}
                  style={{
                    marginRight: "0.3rem",
                    marginTop: "10px",
                    color: "#0d6efd",
                  }}
                />
              }
              onClick={(e) => { e.stopPropagation(); handleUnlikeJob(job.id); }}
            />
          )}
          {job.job_tier != 1 && (
            <div className="joyride-refer-candidate">
              <LinkButton
                label="Refer"
                onClick={(e) => { e.stopPropagation(); history.push(`/home/${job.id}/refer`); }}
                icon={
                  <FaShareAlt
                    size={14}
                    style={{
                      marginRight: "0.3rem",
                      marginTop: "10px",
                      color: "#0d6efd",
                    }}
                  />
                }
              />
            </div>
          )}

          <div className="joyride-request-apply-candidate">
            {isRecruiter === 1 && job.canRecruiterRequest === "1" ? (
              <LinkButton
                label="Request"
                onClick={(e) => { e.stopPropagation(); history.push(`/home/${job.id}`); }}
              />
            ) : (
              <LinkButton
                icon={
                  <FaRegPaperPlane
                    size={14}
                    style={{
                      marginRight: "0.3rem",
                      marginTop: "10px",
                      color: "#0d6efd",
                    }}
                  />
                }
                label="Apply"
                onClick={(e) => { e.stopPropagation(); history.push(`/home/${job.id}/apply`); }}
              />
            )}
          </div>
        </div>
      </Card>

      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "15rem",
            marginTop: "0.2rem",
            borderRadius: "1rem",
            boxShadow: "0px 0px 5px -3px rgba(0,0,0,0.2)",
          },
        }}
      >
        <MenuItem
          className="px-4 py-2 medium-text"
          onClick={() => handleSaveJob(job.id)}
        >
          Save
        </MenuItem>
        {job.job_tier != 1 && (
          <MenuItem
            className="px-4 py-2 medium-text"
            onClick={() => handleShareJob(job.id)}
          >
            Share
          </MenuItem>
        )}
        {/* <MenuItem className="px-4 py-2 medium-text" onClick={handleClose()}>
          Hide Post
        </MenuItem> */}
        <Divider />
        <MenuItem
          className="px-4 py-3 co-lightred medium-text"
          onClick={() => handleReportJob(job.id)}
        >
          Report This Post
        </MenuItem>
      </Menu>

      {report && (
        <Dialog
          open={report}
          onClose={handleReportClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Report Post</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Let us know why you want to report this job
            </DialogContentText>
            <CustomTextArea
              id="report_reason"
              label=""
              value={reportReason}
              onChange={(e) => handleReportChange(e)}
              isRequired
            />
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={handleClose} color="primary">
              Cancel
            </Button> */}
            <Button onClick={() => handleReportSubmit(job.id)} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default JobCard;
